import { useRef, useState } from "react";
import { AgGridReact } from "ag-grid-react";
import Actionbar from "src/components/common/actionbar/Authactionbar";
import { Message } from "src/components/common/form/Message";
import { SearchSection_MST1060_R10 } from "./SearchSection_MST1060_R10";
import { MST1060_R10Table } from "./Table_MST1060_R10";
import { Content_MST1060_R10 } from "./Content_MST1060_R10";
import { MST1060_R10Dto } from "./Dto_MST1060_R10";

export const Container_MST1060_R10 = () => {
	const gridRef = useRef<AgGridReact<MST1060_R10Dto>>(null);

	// 편집 중인 바코드 데이터
	const [editBarcode, setEditBarcode] = useState<MST1060_R10Dto | null>(null);

	const {
		clickable, setClickable,
		handleExcelClick,
		fetchData,
		defaultMST1060_R10Row,
		initContainerData,
		handleInsertClick,
		handleDeleteClick,
		handleSaveClick,
	} = Content_MST1060_R10({
		gridRef,
		editBarcode,
		setEditBarcode
	});

	return (
		<div className="content-container">
			<Actionbar
				onFetchClick={fetchData}
				onCreateClick={handleInsertClick}
				onDeleteClick={handleDeleteClick}
				onSaveClick={handleSaveClick}
				onInitClick={initContainerData}
				onExcelClick={handleExcelClick}
			/>
			<SearchSection_MST1060_R10 onEnterKeyDown={()=> {fetchData(); }} />
			
			<div className="flex flex-col flex-1 px-[12px] gap-[4px] p-[10px]">
				<div className="w-full h-full">
					<MST1060_R10Table 
						gridRef={gridRef} 
						clickable={clickable}
						setClickable={setClickable}
						defaultMST1060_R10Row={defaultMST1060_R10Row()}
						handleInsertClick={handleInsertClick}
					/>
				</div>
			</div>
			
			<Message />
		</div>
	);
};

